export default __webpack_public_path__ + "static/media/2019-AMcover.2d51999f.jpg";